import { useSnackbar } from '@/features/snackbar';
import { ValidationErrors } from '../../utils/validation';
import { ValuatorData } from '../../utils';
import { useEffect } from 'react';

const NARRATIVE_VALUATOR_SNACKBAR_ERROR = 'NARRATIVE_VALUATOR_SNACKBAR_ERROR';

export const useNarrativeErrorToast = ({
  errors,
  submitCount,
}: {
  errors: ValidationErrors<ValuatorData>;
  submitCount: number;
}) => {
  const firstErrorMessage = Object.values(errors).find(Boolean);
  const { addSnackbar, removeSnackbar } = useSnackbar();

  useEffect(() => {
    if (submitCount === 0) return;

    const dismiss = () =>
      removeSnackbar({
        id: NARRATIVE_VALUATOR_SNACKBAR_ERROR,
      });

    if (!firstErrorMessage) return dismiss();

    addSnackbar({
      id: NARRATIVE_VALUATOR_SNACKBAR_ERROR,
      type: 'negative',
      message: firstErrorMessage ?? 'Form has invalid fields',
      lifeTime: 5_000,
      actionLabel: 'Dismiss',
      actionCallback: dismiss,
    });

    return () => {
      dismiss();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstErrorMessage, submitCount]);
};
